import { ActionReducer, MetaReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';
import { AppState } from '.';

export function storageReducer(
  reducer: ActionReducer<AppState>
): ActionReducer<AppState> {
  return localStorageSync({
    keys: [
      'authentication',
      'core',
      'state',
    ], // Sincroniza las claves necesarias
    rehydrate: true, // Rehidrata el estado al cargar la app
  })(reducer);
}

export const metaReducers: MetaReducer<AppState>[] = [storageReducer];
